import { client } from '@api/client';

import {
	IChangePasswordDTO,
	ICheckPasswordDTO,
	ICheckPhoneNumberDTO,
	IDisable2FAValueDTO,
	ISendCode2FaDTO,
	ISendCode2FaForPasswordDTO,
	IUpdateUserProfileDTO,
} from '@interfaces/user/dto/userProfileDTO';
import { IUserProfile } from '@interfaces/user/userProfile';

import { URL } from './urls';

const {
	userProfileInfo,
	checkPassword,
	changePassword,
	editUserProfile,
	checkPhoneNumber,
	history2Fa,
	historyPassword2Fa,
	sendCodeToNumber,
	sendCodeToNumberForPassword,
	sendCode,
	sendCodeForPassword,
	disable2Fa,
	checkValidPassword,
} = URL;

export const getUserProfile = (): Promise<IUserProfile> => {
	return client.get(userProfileInfo);
};

export const checkUserPassword = ({ password }: ICheckPasswordDTO): Promise<boolean> => {
	return client.post(checkPassword, { password });
};

export const getHistory2Fa = (): Promise<number> => {
	return client.get(history2Fa);
};

export const getHistoryPassword2Fa = (): Promise<number> => {
	return client.get(historyPassword2Fa);
};

export const changeUserPassword = ({
	newPassword,
	oldPassword,
}: IChangePasswordDTO): Promise<boolean> => {
	return client.post(changePassword, {
		newPassword,
		oldPassword,
	});
};

export const updateUserProfile = (data: IUpdateUserProfileDTO): Promise<void> => {
	return client.post(editUserProfile, data);
};

export const checkPhoneNumberFor2Fa = ({ number }: ICheckPhoneNumberDTO): Promise<boolean> => {
	return client.post(checkPhoneNumber, { number });
};

export const send2FaCodeToNumber = ({ number }: ICheckPhoneNumberDTO): Promise<void> => {
	return client.post(sendCodeToNumber, { number });
};

export const send2FaCodeToNumberForPassword = (): Promise<void> => {
	return client.post(sendCodeToNumberForPassword, {});
};

export const send2FaCode = ({ number, code }: ISendCode2FaDTO): Promise<void> => {
	return client.post(sendCode, { code, number });
};

export const send2FaCodeForPassword = ({
	code,
	newPassword,
	oldPassword,
}: ISendCode2FaForPasswordDTO & IChangePasswordDTO): Promise<void> => {
	return client.post(sendCodeForPassword, {
		code,
		newPassword,
		oldPassword,
	});
};

export const switchOff2Fa = ({ password }: IDisable2FAValueDTO): Promise<void> => {
	return client.post(disable2Fa, { password });
};

export const checkValidUserPassword = ({ password }: ICheckPasswordDTO): Promise<boolean> => {
	return client.post(checkValidPassword, { password });
};
